import { vatMapping } from '../../util/vatCalculations'

// vat unit dropdown label and value for job item row
export const vatUnitOptions = Object.entries(vatMapping).map(([key, value]) => {
  return {
    value: key,
    label: value.label,
  }
})
